import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {Card, Loader, Row, Col, SearchField} from 'components';
import {Button, Icon, Table, PageFooter, Pagination} from 'components/layout';
import {Checkbox} from 'components/forms';
import Callout from 'components/tools/Callout';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';

function getIn(obj, key) {
  let keys = key.split('.');
  let output = obj;

  while (keys.length > 0) {
    if (output && typeof output === 'object' && Object.keys(output).length) {
      output = output[keys.shift()];
    } else {
      break;
    }
  }
  return output;
}

let headings;

class Report extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      sortKey: 'Score.Total',
      sortDirection: 'desc',
      showIgnored: false,
      search: '',
    };
  }

  componentWillMount() {
    let {formatMessage} = this.props.intl;

    if (!this.props.results) {
      this.props.getResults(this.state);
    }
    headings = [
      {label: formatMessage({id: 'general.account'}), sortKey: 'Account1'},
      {label: formatMessage({id: 'general.customer'}), sortKey: 'Name1'},
      {label: formatMessage({id: 'general.account'}), sortKey: 'Account2'},
      {label: formatMessage({id: 'tools.merge.potencial.match'}), sortKey: 'Name2'},
      {label: formatMessage({id: 'tools.merge.match.score'}), sortKey: 'Score.Total', style: {textAlign: 'center'}},
      undefined,
    ];
  }

  componentDidMount() {
    window.scroll(0, 0);
  }

  componentDidUpdate(_, prevState) {
    let updatable = ['sortKey', 'sortDirection', 'page', 'showIgnored', 'search'];

    if (updatable.some(x => prevState[x] !== this.state[x])) {
      this.props.getResults(this.state);
    }
  }

  changeHidden = ({value}) => {
    this.setState({showIgnored: value});
  };

  changePage = page => {
    this.setState({page});
  };

  search =  (term) => {
    this.setState({
      search: term,
      page: 1,
    });
  };

  sort = key => {
    if (key === this.state.sortKey) {
      this.setState({
        sortDirection: this.state.sortDirection === 'asc' ? 'desc' : 'asc',
      });
    } else {
      this.setState({
        sortKey: key,
        sortDirection: 'asc',
      });
    }
  };

  render() {
    let rows = [];

    if (this.props.results && this.props.results.length) {
      rows = this.props.results
        .map(d => <Record account1={d.Account1} account2={d.Account2} name1={d.Name1} compare={this.props.compare}
                          name2={d.Name2} score={d.Score.Total} id1={d.ID1} id2={d.ID2} key={d.ID1 + '.' + d.ID2} compareLabel={this.props.intl.formatMessage({id: 'tools.merge.compare'})}/>);
    }

    return <div>
      <Loader loaded={!!this.props.results}>
        <Card fullWidth>
          <Row>
            <Col md={4}  className='semi-bold'>
              <p style={{fontSize: '1.1em'}}>
                <Icon name='help-circle' className='blue fa-lg'/>&nbsp;<Callout>{this.props.total}</Callout> <FormattedMessage id="tools.merge.accounts.found" />
              </p>
            </Col>
            <Col md={8}>
              <SearchField onSearch={this.search}
                placeholder={this.props.intl.formatMessage({id: 'general.search.special.character'})} autoFocus={false} />
            </Col>
          </Row>
          <Row>
            <Col md={4}>
              <Checkbox value={this.state.showIgnored} dataChanged={this.changeHidden} label={this.props.intl.formatMessage({id: 'tools.merge.show.accounts'})} />
            </Col>
          </Row>
        </Card>
        <Table headings={headings} rows={rows} sort={this.sort} currentSort={this.state.sortKey} sortDirection={this.state.sortDirection} />
      </Loader>
      <PageFooter className='tc'>
        <Pagination page={this.state.page} total={this.props.total} count={25} onPageChange={this.changePage} />
      </PageFooter>
    </div>;
  }
}
Report.propTypes = {
  compare: PropTypes.func.isRequired,
  getResults: PropTypes.func.isRequired,
  results: PropTypes.array,
  total: PropTypes.number,
  search: PropTypes.string,
};

function Record({account1, account2, name1, name2, score, id1, id2, compare, compareLabel}) {
  const totalScore = score > 1 ? 1 : score;

  return <tr>
    <td>{account1}</td>
    <td>{name1}</td>
    <td>{account2}</td>
    <td>{name2}</td>
    <td style={{textAlign: 'center'}}>{Math.round(totalScore * 100) + ' %'}</td>
    <td><Button link underline onClick={() => compare(id1, id2)}>{compareLabel}</Button></td>
  </tr>;
}
Record.propTypes = {
  account1: PropTypes.string.isRequired,
  account2: PropTypes.string.isRequired,
  compare: PropTypes.func.isRequired,
  compareLabel: PropTypes.string.isRequired,
  id1: PropTypes.number.isRequired,
  id2: PropTypes.number.isRequired,
  name1: PropTypes.string.isRequired,
  name2: PropTypes.string.isRequired,
  score: PropTypes.number.isRequired,
};

export default injectIntl(Report);
